// Angular libs
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { FormsModule } from '@angular/forms';
import { TitleCasePipe } from '@angular/common';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { AngularSplitModule } from 'angular-split';
import { MatRadioModule } from '@angular/material/radio';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { ExportService } from './export.service';
import { AdminService } from '../admin/admin.service';
import { AuthService } from 'src/app/core/auth/auth.service';
import { LocationService } from '../location/location.service';
import { TrapService } from '../location/trap/trap.service';


import { ExportComponent } from './export.component';

const SHORT_DATE_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatListModule,
    MatSelectModule,
    MatOptionModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    FormsModule,
    TitleCasePipe,
    AngularSplitModule,
    MatRadioModule,
    MatToolbarModule,
    MatCheckboxModule,
  ],
  declarations: [
    ExportComponent,
  ],
  providers: [
    ExportService,
    AdminService,
    AuthService,
    LocationService,
    TrapService,
    { provide: MAT_DATE_FORMATS, useValue: SHORT_DATE_FORMATS },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ExportModule { }
